import React, { Fragment } from "react";
import Seo from "../../components/utils/Seo";
import Base from "../Base";
import BodyHome from "./BodyHome";

const HomePage = (props) => {
  return (
    <Fragment>
      <Seo
        title="nti / accueil"
        description="Vente des ordinateurs, laptops, desktops, disque dur rams, unités centrales, souris, claviers et bien plus encore"
      />
      <Base>
        <BodyHome />
      </Base>
    </Fragment>
  );
};

export default HomePage;
